import { Delete } from "lucide-react";

export const PIN_LENGTH = 6;

const POSITIONS = [1, 2, 3, 4, 5, 6];
const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

export function PinPad({
  value,
  onChange,
  disabled = false,
}: {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
}) {
  function press(digit: string) {
    if (disabled || value.length >= PIN_LENGTH) {
      return;
    }
    onChange(value + digit);
  }

  return (
    <div className="pinpad">
      <p className="pinpad__dots" aria-label={`${value.length} de ${PIN_LENGTH} dígitos`}>
        {POSITIONS.map((position) => (
          <span
            key={position}
            className={value.length >= position ? "pinpad__dot pinpad__dot--on" : "pinpad__dot"}
          />
        ))}
      </p>

      <div className="pinpad__keys">
        {KEYS.map((key) => (
          <button
            key={key}
            type="button"
            className="pinpad__key"
            disabled={disabled}
            onClick={() => press(key)}
          >
            {key}
          </button>
        ))}
        <span className="pinpad__slot" />
        <button
          type="button"
          className="pinpad__key"
          disabled={disabled}
          onClick={() => press("0")}
        >
          0
        </button>
        <button
          type="button"
          className="pinpad__key pinpad__key--soft"
          aria-label="Borrar"
          disabled={disabled || value === ""}
          onClick={() => onChange(value.slice(0, -1))}
        >
          <Delete size={22} aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
